import { jsx as _jsx } from "react/jsx-runtime";
import * as dataProcessing from "./dataProcessing";
export var SparklinesReferenceLineTypes;
(function (SparklinesReferenceLineTypes) {
    SparklinesReferenceLineTypes["max"] = "max";
    SparklinesReferenceLineTypes["min"] = "min";
    SparklinesReferenceLineTypes["mean"] = "mean";
    SparklinesReferenceLineTypes["avg"] = "avg";
    SparklinesReferenceLineTypes["median"] = "median";
    SparklinesReferenceLineTypes["custom"] = "custom";
})(SparklinesReferenceLineTypes || (SparklinesReferenceLineTypes = {}));
var SparklinesReferenceLine = function (props) {
    var _a = props.points, points = _a === void 0 ? [] : _a, _b = props.margin, margin = _b === void 0 ? 0 : _b, _c = props.type, type = _c === void 0 ? SparklinesReferenceLineTypes.mean : _c, _d = props.style, style = _d === void 0 ? { stroke: "red", strokeOpacity: 0.75, strokeDasharray: "2, 2" } : _d, value = props.value;
    var ypoints = points.map(function (p) { return p.y; });
    var y = type == "custom"
        ? value
        : dataProcessing[type](ypoints);
    return (_jsx("line", { x1: points[0].x, y1: (y ? y : 0) + margin, x2: points[points.length - 1].x, y2: (y ? y : 0) + margin, style: style }));
};
export default SparklinesReferenceLine;
